import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'examinationIndex',
    component: () => import('@/views/examination(22524)/index.vue'),
  }, {
    path: "/examination/examinationDetail",
    name: 'examinationDetail',
    component: () => import('@/views/examination(22524)/examinationDetail.vue'),
  },
  {
    path: "/download/index",
    name: 'downloadIndex',
    component: () => import('@/views/download/index.vue'),
    meta: {
      title: "水灵子舞蹈"
    }
  }, {
    path: "/download/privacy",
    name: 'privacyPage',
    component: () => import('@/views/download/privacy.vue'),
    meta: {
      title: "隐私政策"
    }
  }, {
    path: "/download/share",
    name: 'sharePage',
    component: () => import('@/views/download/share.vue'),
    meta: {
      title: "水灵子舞蹈"
    }
  }, {
    path: "/slz/vipPay",
    name: 'slzPay',
    component: () => import('@/views/slzPay/index.vue'),
    meta: {
      title: "套餐付款"
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),//头部有#/
  // history:createWebHistory("/vote/"),//头部没有#/
  routes
})

export default router
